// Shared hook: does the current user manage this event?
//
// Consumers pass event_kind + event_id and get back a boolean.
// Reads AuthContext.managedEvents (universal Feb 2026) with an added
// fallback to managedSessions for pre-042 code paths that still
// reference the legacy list.
//
// Kept intentionally tiny — this is called from many list rows so
// there's no fetching, only in-memory membership checks.

import { useAuth } from '../contexts/AuthContext';

export function useCanManageEvent(eventKind, eventId) {
  const { user, managedEvents, managedSessions } = useAuth();
  if (!user || !eventKind || !eventId) return false;
  if (user.role === 'admin') return true;
  const inUniversal = Array.isArray(managedEvents)
    && managedEvents.some((m) => m.event_kind === eventKind && m.event_id === eventId);
  if (inUniversal) return true;
  // Legacy compat: some list surfaces load before /auth/me finishes
  // repopulating managedEvents. For event_session we also check the
  // pre-existing managedSessions list.
  if (eventKind === 'event_session'
      && Array.isArray(managedSessions)
      && managedSessions.includes(eventId)) {
    return true;
  }
  return false;
}

// Returns the correct in-app management route for a given event kind.
export function eventManageHref(eventKind, eventId) {
  switch (eventKind) {
    case 'tournament':    return `/tournaments/${eventId}/manage`;
    case 'round_robin':   return `/round-robins/${eventId}/manage`;
    case 'club_event':    return `/admin/club-events/${eventId}`;
    case 'event_session': return `/admin/events/${eventId}`;
    default:              return null;
  }
}
